import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/customer/dashboard/auth/CustomerLogin.css';

const CustomerLogin = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const { baseUrl, regexChecker, setLoggedInCustomer } = useContext(AppContext);
  const [email, setEmail] = useState('');   
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);

  const [Loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  // ✅ NEW: agar booking screen (VenueDetailPage/PackagesDetail) se
  // redirectTo state ke saath yahan bheja gaya hai, to login ke baad wahi
  // wapas jayenge (venue/package data bhi saath le jayenge). Warna normal
  // dashboard pe.
  const goAfterLogin = () => {
    if (location.state?.redirectTo) {
      navigate(location.state.redirectTo, {
        state: {
          venue: location.state.venue,
          package: location.state.package
        }
      });
    } else {
      navigate('/customer/dashboard');
    }
  };

  useEffect(() => {
    const customerEmail = localStorage.getItem('customerEmail');
    const customerPassword = localStorage.getItem('customerPassword');

    if (customerEmail != null && customerPassword != null) {
      customerAutoLogin(customerEmail, customerPassword);
    }
  }, []);

  const customerAutoLogin = (customerEmail, customerPassword) => {

    const formdata = new FormData();
    formdata.append('email', customerEmail);
    formdata.append('password', customerPassword);

    axios
      .post(`${baseUrl}/customer/auth/customerlogin`, formdata)

      .then((response) => {
        console.log("***********auto login ka function chl rha ha", response.data)

        if (response.data.success == true) {
          setLoggedInCustomer(response.data.customer);
          goAfterLogin();
        } else {
          setErrorMessage('Invalid email or password');
        }
      })

      .catch((error) => {
        setErrorMessage(
          error.response?.data?.message || 'Something went wrong!'
        );
      })
      .finally(() => setLoading(false));
  };

  const customerLogin = () => {

    // ✅ Pehle empty field check karo
    if (!email || !password) {
      setErrorMessage('Email aur Password dono bharo!');
      return;
    }

    // ✅ Validation errors check karo
    const emailErr = regexChecker('email', email);
    const passwordErr = regexChecker('password', password);

    setEmailError(emailErr);
    setPasswordError(passwordErr);

    if (emailErr || passwordErr) {
      return;
    }

    setErrorMessage('');
    setLoading(true);

    const formdata = new FormData();
    formdata.append('email', email);
    formdata.append('password', password);

    axios
      .post(`${baseUrl}/customer/auth/customerlogin`, formdata)

      .then((response) => {
        if (response.data.success == true) {
          console.log(response.data);

          localStorage.setItem('customerEmail', response.data.customer.email);
          localStorage.setItem('customerPassword', response.data.customer.password);
          localStorage.setItem('loggedInCustomer', JSON.stringify(response.data.customer));
          setLoggedInCustomer(response.data.customer)
          goAfterLogin();
        } else {
          setErrorMessage('Invalid email or password');
          setLoading(false);
        }
      })

      .catch((error) => {
        setErrorMessage(
          error.response?.data?.message || 'Something went wrong!'
        );
        setLoading(false);
      }).finally(()=>setLoading(false));
  };

  return Loading ? (

    <div
      style={{ height: '100vh' }}
      className="d-flex justify-content-center align-items-center"
    >
      <Spinner style={{ height: 50, width: 50 }} />
    </div>

  ) : (

    <div className="lgn-root">
      <div className="lgn-page">

        {/* LEFT SIDE */}
        <div className="lgn-left">

          <img
            src="https://i.pinimg.com/736x/63/ba/63/63ba63db62d89478edf720c7eaaf483f.jpg"
            alt="Bridely Wedding"
            className="lgn-bg-img"
          />

          <div className="lgn-left-overlay" />

          <div className="lgn-left-brand">

            <div className="lgn-brand-icon">
              <span className="lgn-brand-letter">B</span>
            </div>

            <span className="lgn-brand-name">
              Bridely
            </span>

          </div>

          <div className="lgn-left-content">

            <p className="lgn-left-script">
              Welcome back to
            </p>

            <h2 className="lgn-left-title">
              Your Perfect
              <br />
              Wedding Journey
            </h2>

            <div className="lgn-left-dots">
              <div className="lgn-dot lgn-dot--active" />
              <div className="lgn-dot" />
              <div className="lgn-dot" />
            </div>

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="lgn-right">

          <div className="lgn-card">

            <div className="lgn-card-header">

              <p className="lgn-greeting">
                Hello again 👋
              </p>

              <h1 className="lgn-title">
                Login
              </h1>

              <p className="lgn-subtitle">
                Sign in to manage your wedding plans,
                bookings, and beautiful memories.
              </p>

            </div>

            <form>

              {/* EMAIL */}
              <div className="lgn-form-group">

                <label className="lgn-label">
                  Email
                </label>

                <div className="lgn-input-wrap">

                  <span className="lgn-input-icon">
                    ✉️
                  </span>

                  <input
                    type="email"
                    className={`lgn-input ${emailError ? 'input-error' : ''}`}
                    placeholder="Enter your Email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setEmailError(regexChecker('email', e.target.value));
                    }}
                    autoComplete="off"
                  />

                </div>

                {emailError && (
                  <p style={{ color: 'red', fontSize: '13px' }}>
                    {emailError}
                  </p>
                )}

              </div>

              {/* PASSWORD */}
              <div className="lgn-form-group">

                <label className="lgn-label">
                  Password
                </label>

                <div className="lgn-input-wrap">

                  <span className="lgn-input-icon">
                    🔒
                  </span>

                  <input
                    type={showPwd ? 'text' : 'password'}
                    className={`lgn-input ${passwordError ? 'input-error' : ''}`}
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError(regexChecker('password', e.target.value));
                    }}
                    autoComplete="off"
                  />

                  <button
                    type="button"
                    className="lgn-eye-btn"
                    onClick={() => setShowPwd(!showPwd)}
                  >
                    {showPwd ? '🙈' : '👁️'}
                  </button>

                </div>

                {passwordError && (
                  <p style={{ color: 'red', fontSize: '13px' }}>
                    {passwordError}
                  </p>
                )}

              </div>

              {/* GLOBAL ERROR */}
              {errorMessage && (
                <p style={{ color: 'red', marginBottom: '10px' }}>
                  {errorMessage}
                </p>
              )}

              {/* FORGOT PASSWORD */}
              <div className="lgn-forgot-row">

                <Link
                  to="/customer/forgot-password"
                  className="lgn-forgot-link"
                >
                  Forgot password?
                </Link>

              </div>

              {/* BUTTON */}
              <button
                type="button"
                className="lgn-btn-submit"
                disabled={Loading}
                onClick={customerLogin}
              >
                {Loading ? 'Signing in... ⏳' : 'Login →'}
              </button>

            </form>

            {/* REGISTER */}
            <div className="lgn-register-row">

              Don't have an account?{' '}

              <Link
                to="/customer/register"
                className="mnb-btn-login"
              >
                Register here
              </Link>

            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default CustomerLogin;